module.exports = __webpack_public_path__ + "img/ger_242_btn2.560413a4.png";